import React, { Component } from 'react';

interface PromoMessageControlProps {
    message: string;
}

export class PromoMessageImportantControl extends Component<PromoMessageControlProps> {    
    constructor(props) {
        super(props);
    }

    render() {
        let message = null;
        if(this.props.message != "")
            message = (
                <div className="alert alert-warning">
                    <div dangerouslySetInnerHTML={{__html: this.props.message}} />
                </div>);
                
        return (
                <div className="col-xs-12 col-sm-offset-4 col-sm-4">
                    {message}
                </div>
        );
    }
}